import './source_view.js.coffee'
Namespace 'Settings.Views.Topics'

class Settings.Views.Topics.ClippingSourceView extends Settings.Views.Topics.SourceView
  id: 'new_clipping_source'
  icon: image_path('clipping.png')
  template: JST['backbone/templates/settings/topics/clipping_source']
  channelViewClass: Settings.Views.Topics.ClippingChannelView

  events:
    'click .create-source': 'createSource'
    'click #new_clipping_source': 'initialCheck'

  initialize: ({sourceListEl, newSourceButtonsEl}) ->
    @sourceListEl = sourceListEl
    @newSourceButtonsEl = newSourceButtonsEl

  render: ->
    @$el.html @template
      sourceIcon: @icon
    @aceptbutton = @$el.find('.create-source')
    @

  createSource: ->
    @$el.addClass('hidden')
    @channelView.remove() if @channelView
    @channelView = new @channelViewClass
      sourceIndex: '__index__'
      allowRemove: true
    @sourceListEl.prepend(@channelView.render().el)
    @showAndDisableNewSourceButtons()
